module.exports = __webpack_public_path__ + "static/media/shape_W.3688b4bb.glb";